import { RubricatorPage } from "./page";

export default RubricatorPage;
